import mainServerClient from "../http/mainServerClient";

export enum LoggerInfoTag {
    CN_PRINTER_ERROR = "CN_PRINTER_ERROR",
    DY_PRINTER_ERROR = "DY_PRINTER_ERROR",
    JD_PRINTER_ERROR = "JD_PRINTER_ERROR",
    PDD_PRINTER_ERROR = "PDD_PRINTER_ERROR",
    KS_PRINTER_ERROR = "KS_PRINTER_ERROR",

    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",

    REQUEST_MISSING_PARAMS = "REQUEST_MISSING_PARAMS",

    REQUEST_NETWORK_ERROR = "REQUEST_NETWORK_ERROR",

    MARK_PRINT_FAIL_ORDER = "MARK_PRINT_FAIL_ORDER",

    LOCAL_DOUBLE_ADDRESS = "LOCAL_DOUBLE_ADDRESS",

    PDD_DEVICE_FINGER = "PDD_DEVICE_FINGER",

    ORDER_DATA_ERROR = "ORDER_DATA_ERROR",

    UPDATE_PRINT_INDEX = "UPDATE_PRINT_INDEX",
}

interface LoggerInfo {
    tag: LoggerInfoTag;
    content: string;
}

export function postLogInfo(info: LoggerInfo, config?) {
    return mainServerClient.post("/frontend_logger/info", info, config);
}
